export enum ConsultationRequestType {
    Transfer = 1,
    Referral = 2,
    Consultation = 3,
}